import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { getDealSecurities } from '@dealstack/frontend/shared/dataExchange/services/securities';
import type { DealEventFilterOption } from '@dealstack/frontend/app/pages/Project/DealEventLog/utils/dealEventLogFilterOptions.utils.ts';

const SECURITY_STALE_TIME_MS = 300_000;

export const useDealEventSecurities = (dealId: string, enabled: boolean) => {
	const query = useQuery({
		queryKey: [API_PATHS.SECURITY_DEAL_GET, { dealId }],
		queryFn: () => getDealSecurities(API_PATHS.SECURITY_DEAL_GET),
		enabled: enabled && !!dealId,
		staleTime: SECURITY_STALE_TIME_MS,
		gcTime: SECURITY_STALE_TIME_MS,
	});

	return useMemo<DealEventFilterOption[]>(
		() => (query.data ?? []).map(({ id, name }) => ({ value: id, label: name })),
		[query.data]
	);
};
